import NonInclus from '@amo/core/assets/images/icons/non_inclus.svg';
import Star from '@amo/core/assets/images/icons/star.png';
import Moto from '@amo/core/assets/images/AMO_Icons/Moto.svg';
import MotoWhite from '@amo/core/assets/images/AMO_Icons/Moto-white.svg';
import {RadioBtn} from '@amo/core/components/forms';
import _ from 'lodash';
import {Field} from 'redux-form';
import Slider from "react-slick";
import getPriceByFractionnementOrCodePromo from '../../utilsTarif/getPriceByFractionnementOrCodePromo';
import './table.scss';
import {getTranslation} from "@amo/core/utils/index.js";

const TableFormule = (props) => {
    const {formulePreconisee, formules, formuleChoisie, fractionnementChoisi, codePromo, analyticsSetEvent, changeValue, vehicule} = props;

    const convertPriceToFloat = (price) => parseFloat(price.replace('€', '').trim().replace(',', '.'));

    const buildLabelFormule = (f) => {
        const priceData = getPriceByFractionnementOrCodePromo(f, fractionnementChoisi);
        const isPromoEligible = codePromo?.Eligible && convertPriceToFloat(priceData.prix) > convertPriceToFloat(priceData.prixPromo);

        return `
            <span data-cy="title" class="${f.CodeFormule === formuleChoisie?.CodeFormule ? 'text-warning' : 'text-dark'} d-block fw-bold f-24">${f.LibelleFormule}</span>
            <span data-cy="price" class="${f.CodeFormule === formuleChoisie?.CodeFormule ? 'text-white' : 'text-primary'} d-block h4 f-40 fw-bold text-nowrap">${isPromoEligible ? priceData.prixPromo : priceData.prix} 
            <small class="${f.CodeFormule === formuleChoisie?.CodeFormule ? 'text-white' : 'text-primary'}">TTC/${fractionnementChoisi === 'M' ? getTranslation('months') : getTranslation('year')}</small></span>
            ${isPromoEligible ? `<span class="d-block text-muted text-decoration-line-through">${priceData.prix} <small>TTC/${fractionnementChoisi === 'M' ? getTranslation('months') : getTranslation('year')}</small></span>` : ''}
            <hr/>        
        `;
    };

    const renderStars = (formule) => {
        const starCount = formule.CodeFormule === 'F1' ? 1 : formule.CodeFormule === 'F2' ? 2 : 3;
        return (
            <div className="stars-container d-flex justify-content-center mt-2" role="img" aria-label={`${starCount} étoile${starCount > 1 ? 's' : ''} sur 3`}>
                {_.times(starCount, (i) => (
                    <img key={i} src={Star} alt="" className="star-icon mx-1" width={30} loading="lazy" aria-hidden="true"/>
                ))}
            </div>
        );
    };

    const renderDescription = (formule) => {
        const {brand} = vehicule || {};
        const descriptions = {
            F1: getTranslation('pricing.descriptionPlanF1', {brand: brand?.name}),
            F2: getTranslation('pricing.descriptionPlanF2', {brand: brand?.name}),
            F3: getTranslation('pricing.descriptionPlanF4', {brand: brand?.name}),
            F4: getTranslation('pricing.descriptionPlanF4', {brand: brand?.name}),
        };
        return <p className="f-13 mx-2" dangerouslySetInnerHTML={{__html: descriptions[formule.CodeFormule]}}/>;
    };

    const renderGuarantees = (formule, allGuarantees) => (
        <ul className="row mt-3 list-unstyled mb-0" aria-label={`Garanties de la formule ${formule.LibelleFormule}`}>
            {allGuarantees.map((garantie, index) => {
                const isIncluded = _.find(formule.ListeGaranties, (h) => h.CodeGarantie === garantie.CodeGarantie && h.Disponible === 'Inclusion');
                return (
                    <li
                        key={index}
                        className={`p-2 f-13 text-start d-flex align-items-center ${index === allGuarantees.length - 1 ? 'pb-5' : ''}`}
                    >
                        {isIncluded
                            ? <span className="check-icon w-20 me-2" aria-hidden="true"></span>
                            : <img src={NonInclus} alt="" className="me-2" width={20} loading="lazy" aria-hidden="true"/>}
                        <span className={isIncluded ? '' : 'text-grey'}>
                            {garantie.LibelleGarantie}
                            <span className="visually-hidden"> - {isIncluded ? 'inclus' : 'non inclus'}</span>
                        </span>
                    </li>
                );
            })}
        </ul>
    );

    const PrevArrow = (props) => {
        const { onClick } = props;
        return (
            <button
                type="button"
                className="slick-prev"
                onClick={onClick}
                aria-label="Formule précédente"
            />
        );
    };

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <button
                type="button"
                className="slick-next"
                onClick={onClick}
                aria-label="Formule suivante"
            />
        );
    };

    const settings = {
        dots: true,
        // RGAA 7.3 : infinite crée des slides clonées qui dupliquent les boutons radio du groupe
        // FormuleChoisie et sont re-créées à chaque changement — le focus s'y perd et la TA relit la page
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        customPaging: (i) => (
            <button type="button" aria-label={`Aller à la formule ${i + 1}`} />
        ),
        // RGAA 7.1 (pattern ARIA carrousel groupé) : les puces doivent être regroupées
        // dans un conteneur role="group" nommé
        appendDots: (dots) => (
            <ul role="group" aria-label="Choisir la formule à afficher">
                {dots}
            </ul>
        ),
    };

    const lastFormula = _.last(formules);
    const inclusionGuarantees = lastFormula?.ListeGaranties.filter(g => g.Disponible === 'Inclusion') || [];

    const renderCard = (f) => {
        const priceData = getPriceByFractionnementOrCodePromo(f, fractionnementChoisi);
        const priceToDisplay = priceData.prixPromo && codePromo?.Eligible ? priceData.prixPromo : priceData.prix;

        const handleCardClick = () => {
            analyticsSetEvent({
                event: 'changementFormule',
                datas: {changementFormule: {formule: f.LibelleFormule.toUpperCase()}},
            });
            changeValue(`DemandeTarif[Police][FormuleChoisie]`, f.CodeFormule);
            changeValue(`options`, {});
            changeValue(`optionsFranchise`, {RAFRAVI: 'false', RAFRADTA: 'false'});
            changeValue(`optionsListe`, {});
        };

        const isSelected = f.CodeFormule === formuleChoisie?.CodeFormule;

        return (
            <div
                className={`col p-3 rounded-3 d-flex flex-column shadow position-relative formule-card
                ${isSelected ? 'bg-primary-dark text-white formule-selected' : 'border border-ternary'}`}
                key={f.CodeFormule}
                onClick={handleCardClick} // Bloc entier cliquable
            >
                {/* RGAA 3.1 - Visually-hidden text for selected formule */}
                {isSelected && <span className="visually-hidden">Formule sélectionnée</span>}
                {
                    formulePreconisee === f.CodeFormule && <div className="ribbon"><span> Recommandée</span></div>
                }

                <div className="text-center flex-grow-1 d-flex flex-column pb-5">
                    <div className="text-center">
                        <span
                            className="d-block"
                            dangerouslySetInnerHTML={{__html: buildLabelFormule(f)}}
                        />
                        {renderStars(f)}
                        {f.CodeFormule === formuleChoisie?.CodeFormule ?
                            <img src={MotoWhite} alt="" aria-hidden="true" className="star-icon d-inline" loading="lazy"/> :
                            <img src={Moto} alt="" aria-hidden="true" className="star-icon d-inline" loading="lazy"/>}
                        {renderDescription(f)}
                    </div>
                    {renderGuarantees(f, inclusionGuarantees)}
                </div>
                <Field
                    component={RadioBtn}
                    type="radio"
                    name="DemandeTarif[Police][FormuleChoisie]"
                    value={f.CodeFormule}
                    label=""
                    className="cursor-pointer p-z3 w-100 margin-moins"
                    onClick={(e) => {
                        e.stopPropagation(); // Empêche le clic sur le bouton de déclencher l'événement du bloc
                        handleCardClick();
                    }}
                >
                    {f.CodeFormule === formuleChoisie?.CodeFormule
                        ? <p className={`btn btn-primary-light btn-smaller cursor-pointer f-12`}>
                            <span className={'check-icon w-20'}/> {getTranslation('pricing.myFormule')}
                        </p>
                        : <p
                            className={`btn btn-primary-dark btn-smaller cursor-pointer f-12`}
                            dangerouslySetInnerHTML={{
                                __html: fractionnementChoisi === 'M'
                                    ? getTranslation('pricing.choiceThisFormuleMonthly', {price: priceToDisplay})
                                    : getTranslation('pricing.choiceThisFormuleAnnualy', {price: priceToDisplay})
                            }}
                        />
                    }
                </Field>
            </div>
        );
    };

    return (
        <div className="container py-4">
            <div className="d-none d-md-flex row d-flex justify-content-center gap-3 h-100 flex-nowrap" role="group" aria-label="Choix de la formule">
                {formules && _.map([...formules], renderCard)}
            </div>
            <section className="d-block d-md-none" aria-roledescription="carrousel" aria-label="Choix de la formule">
                <Slider {...settings}>
                    {formules && _.map(_.reverse([...formules]), renderCard)}
                </Slider>
            </section>
        </div>
    );
};

export default TableFormule;